import { useEffect, useState } from 'react'
import { AccordionDetails, Box, Button, Checkbox, FormControlLabel } from '@mui/material'
import { useDispatch } from 'react-redux'
import GreenCheckbox from './GreenCheckbox.jsx'

const RolesListData = ({ actionToDispatch, rolesStore, userStore, condition }) => {
  const dispatch = useDispatch()

  const [rolesList, setRolesList] = useState([])
  const [selected, setSelected] = useState([])

  useEffect(() => {
    setRolesList(rolesStore?.value[condition])
    setSelected(userStore?.roles && userStore?.roles[condition] ? userStore?.roles[condition] : [])
  }, [rolesStore, userStore])

  const handleRole = (event) => {
    const { checked, id } = event.currentTarget
    const checkedRole = rolesList.find((singleRole) => singleRole.id === +id)
    const newSelectedArr = []

    if (!checked) {
      setSelected([...selected, checkedRole])
      updateUserRolesStore([...selected, checkedRole])
    } else {
      selected.forEach((singleRole) => {
        if (singleRole.id !== +id) {
          newSelectedArr.push(singleRole)
        }
      })

      setSelected(newSelectedArr)
      updateUserRolesStore(newSelectedArr)
    }
  }

  const updateUserRolesStore = (newRoles) => {
    const newData = {
      ...userStore,
      roles: {
        ...userStore.roles,
        [condition]: newRoles,
      },
    }

    dispatch(actionToDispatch({ queries: newData }))
  }

  return (
    <>
      {rolesList?.length > 0 && <FormControlLabel
        sx={styles.optionLabel}
        control={<GreenCheckbox name='checkedG' />}
        label={condition}
      />}

      <AccordionDetails sx={styles.MuiAccordionDetails}>
        {rolesList?.map((singleRole) => (
          <Button style={styles.button} key={singleRole.id}>
            <Box
              sx={
                selected?.find((e) => e.id === singleRole.id)
                  ? styles.buttonActivated
                  : styles.buttonStyle
              }>
              <FormControlLabel
                control={
                  <Checkbox
                    sx={styles.checkedSelected}
                    value={condition.toLowerCase()}
                    name={singleRole.id}
                    onChange={(e) => handleRole(e)}
                    color='primary'
                    id={singleRole.id}
                    checked={!selected?.find((e) => e.id === singleRole.id)}
                  />
                }
                label={singleRole.display_name}
              />
            </Box>
          </Button>
        ))}
      </AccordionDetails>
    </>
  )
}

const styles = {
  optionLabel: {
    textTransform: 'capitalize',
    '& span': {
      fontSize: { xs: '13px', sm: '16px' },
    },
  },
  MuiAccordionDetails: {
    flexWrap: 'wrap',
    padding: { xs: '8px 0px', sm: '8px 16px 16px' },
  },
  button: {
    margin: '5px',
    borderRadius: '20px',
    overflow: 'hidden',
    padding: '0px',
    '& hover': {
      background: 'transparent',
    },
  },
  buttonStyle: {
    margin: '5px',
    borderRadius: { xs: '15px', sm: '20px' },
    border: '1px solid #cfd8dc',
    padding: '0px',
    '& span span:first-child': {
      position: 'absolute',
      visibility: 'hidden',
    },
    '& label': {
      padding: { xs: '7px 10px', sm: '7px 30px' },
      margin: '0px',
      span: {
        fontSize: { xs: '11px', sm: '14px' },
      },
    },
  },
  buttonActivated: {
    margin: '5px',
    borderRadius: '20px',
    backgroundColor: '#29cc8b',
    border: '1px solid #29cc8b',
    color: '#fff',
    padding: '0px',
    '& span span:first-child': {
      position: 'absolute',
      visibility: 'hidden',
    },
    '& label': {
      padding: { xs: '7px 15px', sm: '7px 30px' },
      margin: '0px',
      span: {
        fontSize: { xs: '11px', sm: '14px' },
      },
    },
    '&:hover': {
      backgroundColor: '#29cc8b',
      color: 'fff',
      borderColor: '#29cc8b',
    },
  },
  checkedSelected: {
    display: 'none',
  },
}

export default RolesListData
